const INITIAL_STATE = {
  paymentDaysArray: [],
  paymentDaysArrayExpress: [],
  paymentHistoryArray: [],
  paymentHistoryArrayExpress: [],
  paymentRequestArray: [],
};

const setPaymentsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_ALL_PAYMENT_DAY":
      return { ...state, paymentDaysArray: [...action.payload] };
    case "GET_ALL_PAYMENT_DAY_EXPRESS":
      return { ...state, paymentDaysArrayExpress: [...action.payload] };
    case "GET_ALL_PAYMENTS_OF_SINGLE_DAY":
      return { ...state, paymentHistoryArray: [...action.payload] };
    case "GET_ALL_PAYMENTS_OF_SINGLE_DAY_EXPRESS":
      return { ...state, paymentHistoryArrayExpress: [...action.payload] };
    case "GET_ALL_PAYMENT_REQUEST":
      return { ...state, paymentRequestArray: [...action.payload] };
    case "UPDATE_PAYMENT_REQUEST_STATUS":
      const newRequestArray = state.paymentRequestArray.map(
        (paymentRequest) => {
          if (paymentRequest.paymentId == action.payload.paymentId) {
            return action.payload;
          } else {
            return paymentRequest;
          }
        }
      );
      return { ...state, paymentRequestArray: [...newRequestArray] };
    default:
      return state;
  }
};
export default setPaymentsReducer;
